var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.4,
    height: 23.401,
    viewBox: "0 0 23.4 23.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "task_alt_FILL1_wght500_GRAD200_opsz48",
    d: "M26.13,11.736a12.772,12.772,0,0,1,.309,1.515,11.3,11.3,0,0,1,.112,1.6,11.839,11.839,0,0,1-.9,4.616,11.28,11.28,0,0,1-6.187,6.187,11.839,11.839,0,0,1-4.616.9,11.839,11.839,0,0,1-4.616-.9,11.28,11.28,0,0,1-6.187-6.187,11.839,11.839,0,0,1-.9-4.616,11.839,11.839,0,0,1,.9-4.616,11.28,11.28,0,0,1,6.187-6.187,11.839,11.839,0,0,1,4.616-.9,11.132,11.132,0,0,1,3.339.491,13.9,13.9,0,0,1,2.946,1.3.907.907,0,0,1,.463.687,1.11,1.11,0,0,1-.182.828,1.15,1.15,0,0,1-.7.449,1.054,1.054,0,0,1-.786-.14A10.187,10.187,0,0,0,17.544,5.7,9.2,9.2,0,0,0,14.85,5.31a9.347,9.347,0,0,0-9.54,9.54,9.347,9.347,0,0,0,9.54,9.54,9.369,9.369,0,0,0,9.54-9.54,9.167,9.167,0,0,0-.07-1.164,8.474,8.474,0,0,0-.21-1.08,1.415,1.415,0,0,1,.112-.968,1.109,1.109,0,0,1,.645-.575,1.03,1.03,0,0,1,.758.07A.886.886,0,0,1,26.13,11.736ZM12.437,19.48l-3.367-3.4a1,1,0,0,1-.337-.772,1.053,1.053,0,0,1,.365-.8.973.973,0,0,1,.758-.309,1.161,1.161,0,0,1,.814.309l2.525,2.553L24.222,6.04a1.1,1.1,0,0,1,.772-.323,1.045,1.045,0,0,1,.8.323,1.152,1.152,0,0,1,0,1.627L13.952,19.48a1.039,1.039,0,0,1-.786.365A.879.879,0,0,1,12.437,19.48Z",
    transform: "translate(-3.15 -3.15)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApproved);
export default __webpack_public_path__ + "static/media/icon_approved.c9b48eef8b684288594fd6600159e8b6.svg";
export { ForwardRef as ReactComponent };